/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectCategoryCommand } from '../../models/create-project-category-command';
import { CreateProjectCategoryCommandResult } from '../../models/create-project-category-command-result';

export interface ApiProjectCategoriesCreateProjectCategoryPost$Plain$Params {
  
    /**
     * The details of the Project Category to create.
     */
    body?: CreateProjectCategoryCommand
}

export function apiProjectCategoriesCreateProjectCategoryPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesCreateProjectCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesCreateProjectCategoryPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectCategoryCommandResult>;
    })
  );
}

apiProjectCategoriesCreateProjectCategoryPost$Plain.PATH = '/api/ProjectCategories/CreateProjectCategory';
